import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './style.scss';

export default class CollapsePanel extends PureComponent {
    state = {
        open: this.props.expanded
    };

    togglePanel = () => {
        this.setState(prevState => ({ open: !prevState.open }));
    };

    render() {
        const { title, children, spaceBetween } = this.props;
        const { open } = this.state;
        const togglePanelClassName = classnames('header', {
            'space-between': spaceBetween
        });
        return (
            <div className="collapse-panel">
                <div onClick={this.togglePanel} role="button" className={togglePanelClassName}>
                    <span>{title}</span>
                    <span>
                        <i className={`spark-icon spark-icon-arrow-chevron-${open ? 'up' : 'down'}`} />
                    </span>
                </div>
                {open ? <div className="content">{children}</div> : null}
            </div>
        );
    }
}

CollapsePanel.propTypes = {
    expanded: PropTypes.bool,
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
};

CollapsePanel.defaultProps = {
    expanded: false
};



// WEBPACK FOOTER //
// ./src/components/widgets/CollapsePanel/CollapsePanel.js